// src/components/BrowseSection.tsx

import { Box, Typography, Grid, Chip } from '@mui/material';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';
import DirectionsCarOutlinedIcon from '@mui/icons-material/DirectionsCarOutlined';
import SmartToyIcon from '@mui/icons-material/SmartToy';

const cards = [
    {
        title: 'New Vehicles',
        sub: 'Brand new cars & commercial vehicles',
        href: '/new-vehicles', // Changed from path to href
        icon: <DirectionsCarIcon fontSize="small" />,
        iconBg: '#FFC107', // Yellow
        iconColor: '#FFF',
        arrowColor: 'text.primary',
    },
    {
        title: 'Used Vehicles',
        sub: 'Pre-owned cars & commercial vehicles',
        href: '/used-vehicles', // Changed from path to href
        icon: <DirectionsCarIcon fontSize="small" />,
        iconBg: '#0D6EFD', // Blue
        iconColor: '#FFF',
        arrowColor: 'text.primary',
    },
    {
        title: 'AI Vehicle Finder',
        sub: 'Describe what you need, our AI finds the best match',
        href: '/ai-finder', // Changed from path to href
        icon: <SmartToyIcon fontSize="small" />,
        iconBg: '#7000FF', // Purple
        iconColor: '#FFF',
        arrowColor: '#7000FF', // Purple arrow to match design
        isNew: true,
    },
    {
        title: 'Partner With Us',
        sub: 'Submit your interest to become a partner',
        href: '/partner-with-us/', // Changed from path to href
        icon: <DirectionsCarOutlinedIcon fontSize="small" />,
        iconBg: '#adb0b689', // Light gray
        iconColor: '#0D6EFD', // Blue icon
        arrowColor: 'text.primary',
    },
];

const BrowseSection = () => (
    <Box sx={{ width: '95vw', maxWidth: '1200px', mx: 'auto', mt: { xs: 3, md: 5 }, mb: { xs: 0, md: -2 } }}>
        <Grid container spacing={2}>
            {cards.map((card) => (
                <Grid size={{ xs: 12, sm: 6, md: 3 }} key={card.title}>
                    <Box
                        component="a" // Changed from RouterLink to standard HTML anchor "a"
                        href={card.href} // Changed from "to" to "href"
                        sx={{
                            textDecoration: 'none',
                            display: 'flex',
                            alignItems: 'center',
                            px: 2,
                            py: 2.5,
                            height: '100%',
                            borderRadius: 3,
                            border: '1px solid',
                            borderColor: '#E5E7EB',
                            bgcolor: 'background.paper',
                            transition: 'all 0.2s ease-in-out',
                            '&:hover': {
                                borderColor: 'primary.main',
                                boxShadow: '0 4px 20px rgba(0,0,0,0.06)',
                                transform: 'translateY(-2px)'
                            },
                        }}
                    >
                        {/* Circular Icon */}
                        <Box
                            sx={{
                                width: 44,
                                height: 44,
                                borderRadius: '50%',
                                bgcolor: card.iconBg,
                                color: card.iconColor,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                flexShrink: 0,
                                mr: 2,
                            }}
                        >
                            {card.icon}
                        </Box>

                        {/* Text Content */}
                        <Box sx={{ flexGrow: 1 }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', mb: 0.5 }}>
                                <Typography 
                                    variant="subtitle2" 
                                    sx={{ 
                                        fontWeight: 800, 
                                        fontFamily: 'Inter, sans-serif', 
                                        color: 'text.primary',
                                        fontSize: '0.85rem'
                                    }}
                                >
                                    {card.title}
                                </Typography>
                                {card.isNew && (
                                    <Chip 
                                        label="New" 
                                        size="small" 
                                        sx={{ 
                                            ml: 1, 
                                            height: 18, 
                                            fontSize: '0.65rem', 
                                            fontWeight: 700, 
                                            bgcolor: '#F3E8FF', 
                                            color: '#7000FF',
                                            '& .MuiChip-label': { px: 1 }
                                        }} 
                                    />
                                )}
                            </Box>
                            <Typography 
                                variant="body2" 
                                color="text.secondary" 
                                sx={{ 
                                    fontSize: '0.75rem', 
                                    lineHeight: 1.4,
                                    fontWeight: 500
                                }}
                            >
                                {card.sub}
                            </Typography>
                        </Box>

                        {/* Arrow */}
                        <ChevronRightIcon 
                            sx={{ 
                                color: card.arrowColor, 
                                fontSize: '1.2rem', 
                                flexShrink: 0, 
                                ml: 1,
                                fontWeight: 700
                            }} 
                        />
                    </Box>
                </Grid>
            ))}
        </Grid>
    </Box>
);

export default BrowseSection;